import { fetchCachedPublicGet } from "./publicRequest";

const buildQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  ).toString();
  return query ? `?${query}` : "";
};

export const fetchCamps = (params = {}, options = {}) =>
  fetchCachedPublicGet(`/explore/camps${buildQuery(params)}`, options);

export const fetchExploreFeed = (params = {}, options = {}) =>
  fetchCachedPublicGet(`/explore/feed${buildQuery(params)}`, options);

export const fetchExploreStats = (options = {}) =>
  fetchCachedPublicGet('/explore/stats', options);

export const fetchCampDetail = (destinationSlug, campSlug, options = {}) => {
  if (!destinationSlug || !campSlug) {
    return Promise.reject(new Error("Destination or camp slug missing"));
  }
  const requestOptions = { ...options };
  delete requestOptions.view;
  const path = `/explore/destinations/${destinationSlug}/camps/${campSlug}${buildQuery({ view: options.view })}`;
  return fetchCachedPublicGet(path, requestOptions);
};

export const fetchDestinationCamps = (destinationSlug, options = {}) => {
  if (!destinationSlug) {
    return Promise.reject(new Error("Destination slug missing"));
  }
  const requestOptions = { ...options };
  const params = new URLSearchParams();
  if (requestOptions.includeRooms) {
    params.set("includeRooms", "1");
  }
  ["view", "limit", "cursor"].forEach((key) => {
    if (requestOptions[key] !== undefined && requestOptions[key] !== null && requestOptions[key] !== "") {
      params.set(key, requestOptions[key]);
    }
    delete requestOptions[key];
  });
  delete requestOptions.includeRooms;
  const query = params.toString();
  const path = query
    ? `/explore/destinations/${destinationSlug}/camps?${query}`
    : `/explore/destinations/${destinationSlug}/camps`;
  return fetchCachedPublicGet(path, requestOptions);
};

export const fetchCampRoomCards = (destinationSlug, campSlug, params = {}, options = {}) => {
  if (!destinationSlug || !campSlug) {
    return Promise.reject(new Error("Destination or camp slug missing"));
  }
  return fetchCachedPublicGet(
    `/explore/destinations/${destinationSlug}/camps/${campSlug}/rooms${buildQuery({ view: "cards", includeGallery: 1, ...params })}`,
    options,
  );
};

export const fetchDestinationExperienceCards = (destinationSlug, params = {}, options = {}) => {
  if (!destinationSlug) return Promise.reject(new Error("Destination slug missing"));
  return fetchCachedPublicGet(
    `/explore/destinations/${destinationSlug}/experiences${buildQuery({ view: "cards", ...params })}`,
    options,
  );
};
